import React, {useContext, useEffect, useState} from 'react';
import {DateHelper} from "@bryntum/schedulerpro";
import { Calendar, User } from "lucide-react";
import BryntumContext from "../../../context/bryntumContext.jsx";
import {TriggerKeyForLastUpdatedAt} from "../../../../other/constants/OtherKeys.jsx";
import useNetworkState from "../../../hooks/useNetworkState.jsx";
import { formatNameWithInitials } from '../../../../other/utils/utils.jsx';

let lastUpdateBoardUpdateListener = null;
const LastUpdateText = () => {
  const [lastUpdated, setLastUpdated] = useState(null);
  const { isNetworkRequestInProgress } = useNetworkState();
  const { project, boardManager, selectedBoard } = useContext(BryntumContext);

  useEffect(() => {
    if (project && selectedBoard) {
      setLastUpdated({
        updater: selectedBoard.record.updater,
        updatedAt: selectedBoard.record.updatedAt
      })
      return project.on(TriggerKeyForLastUpdatedAt, ({ updater, updatedAt }) => {
        setLastUpdated({ updater, updatedAt });
      })
    }
  }, [project, selectedBoard]);

  useEffect(() => {
    if (project && boardManager.boardNameStore) {
      lastUpdateBoardUpdateListener = boardManager.boardNameStore.on("update", ({ record }) => {
        if (boardManager.selectedBoard.id === record.id) {
          project.trigger(TriggerKeyForLastUpdatedAt, record);
        }
      });
      return () => lastUpdateBoardUpdateListener();
    }
  }, [project, boardManager.boardNameStore]);

  return (
    <>
      { lastUpdated && <div className="text-muted-foreground text-xs leading-tight">
        <div className="flex flex-wrap items-center justify-end gap-x-3 gap-y-1">
          {isNetworkRequestInProgress ? (
            <i className="fa-duotone fa-loader fa-spin h-3 w-3 shrink-0 text-[10px] leading-none" aria-hidden />
          ) : null}
          {lastUpdated.updater ? (
            <span className="inline-flex items-center gap-1">
              <User className="h-3 w-3 shrink-0" aria-hidden />
              <span className="truncate max-w-[10rem] sm:max-w-[14rem]">{formatNameWithInitials(lastUpdated.updater)}</span>
            </span>
          ) : null}
          <span className="inline-flex items-center gap-1">
            <Calendar className="h-3 w-3 shrink-0" aria-hidden />
            <span>
              {DateHelper.format(new Date(lastUpdated.updatedAt), 'ddd M/D')} at{" "}
              {DateHelper.format(new Date(lastUpdated.updatedAt), 'h:mm A')}
            </span>
          </span>
        </div>
      </div> }
    </>
  );
};

export default LastUpdateText;
